import React, { useMemo } from "react";
import ChartWrapper from "../graph/ChartWrapper";
import {
  CardData,
  CategoryDef,
  LegendType,
} from "api/interfaces/dashboardInterface.interface";
import {
  DashboardRecorderList,
  RecordersType,
} from "api/interfaces/dashboardInterface.interface";
import { useQuery } from "react-query";
import { useAppSelector } from "redux/hooks";
import { ProfileAccountInfo } from "api/interfaces/accountInterface.interface";
import { getDashboardRecorders } from "api/widgetAPI";
import { formatNumber } from "utils/functions";
import useStompDebouncedRefetch, {
  StompDateSignalKey,
} from "hook/useStompDebouncedRefetch";
import { useStatsWidget } from "../graph/GridChartItem";

export default function RecorderTypeCard(props: CardData) {
  const selectedAccount: ProfileAccountInfo = useAppSelector(
    (state) => state.accountSettings
  );
  const { includeSuspended } = useStatsWidget();
  const statsRecorders = useQuery(
    ["statsRecorders", selectedAccount.accountId, includeSuspended],
    () =>
      getDashboardRecorders({
        accountId: selectedAccount.accountId,
        includeSuspended: includeSuspended ?? false,
      }),
    {
      retry: 0,
      refetchOnWindowFocus: false,
    }
  );
  useStompDebouncedRefetch({
    stompKey: ["recorderListUpdated"] as StompDateSignalKey[],
    refetch: statsRecorders.refetch,
  });
  const type = useMemo(
    () => (props.i || "").split("Recorders")[0] as RecordersType,
    [props.i]
  );
  const data = useMemo(() => {
    if (!type) return [];
    return (props.items || [])
      .map((item) => ({
        label: item.label,
        value:
          statsRecorders.data?.result[type].find(
            (r: DashboardRecorderList) => r.type === item.key
          )?.recorder || 0,
      }))
      .sort((a, b) => b.value - a.value);
  }, [props.items, type, statsRecorders.data?.result]);
  const legend: LegendType[] = useMemo(() => {
    return data.map((item) => ({
      label: item.label,
      value: formatNumber(item.value).toString(),
      color: props.items?.find((i) => i.label === item.label)?.color,
    })).sort((a,b) => parseInt(a.label) - parseInt(b.label))
  }, [props.items, data]);
  return (
    <ChartWrapper
      rows={data}
      items={props.items as CategoryDef[]}
      legend={legend}
      isLoading={statsRecorders.isLoading}
    />
  );
}
